<template>
	<div class="list-page">
		<div class="list-page__header">
			<span>采购招商</span>
		</div>
		<div class="list-page__content">
			<div class="purchase-content">
				<ul>
					<router-link
						v-for="business in businessList"
						:key="business.id"
						:to="`/ProjectInvestment/businessDetail/${business.id}`"
						tag="li"
					>
						<span class="span_icon">.</span>
						<span class="span_title">{{ business.title }}</span>
						<span class="span_time">{{
							business.publishtime | formatDate
						}}</span>
					</router-link>
				</ul>
			</div>
		</div>
		<div class="list-page__footer">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page.sync="page"
				:page-size="limit"
				layout="prev, pager, next, jumper"
				:total="businessListTotal"
			>
			</el-pagination>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
	props: {},
	data() {
		return {
			page: 1,
			limit: 10,
		}
	},
	computed: {
		...mapState('XMZS', ['businessList', 'businessListTotal']),
	},
	created() {
		this.fetchBusinessList()
	},
	mounted() {},
	watch: {},
	methods: {
		...mapActions('XMZS', ['fetchBusinessList']),
		handleCurrentChange(currentPage) {
			this.fetchHouseList({ page: currentPage, limit: 10 })
		},
	},
	components: {},
}
</script>

<style lang="scss">
.purchase {
	&-title {
		text-align: center;
		padding: 30px 0px;
		font-size: 28px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(0, 0, 0, 0.85);
		letter-spacing: 2px;
		border-bottom: 1px solid #f0f0f0;
	}
	&-content {
		padding: 30px 40px;
		ul li {
			margin-bottom: 20px;
			display: flex;
			position: relative;
			.span_icon {
				position: absolute;
				top: -20px;
				left: -10px;
				font-size: 30px;
			}
			.span_title {
				flex: 10;
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #000000;
			}
			.span_time {
				font-size: 16px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: rgba(0, 0, 0, 0.35);
			}
		}
	}
}
</style>
